// Core
import React, { useState, useEffect } from "react";

// Components - Contrib Libraries
import { Button, Collapse } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";

// Custom
import { addSticker, findAnchor } from "../assets/utilities";

function Questions(props) {
	const { questions, lastHeaderLoaded } = props;

	const [searchParams] = useSearchParams();

	const [toggleCollapse, setToggleCollapse] = useState();
	const [toggleAllCollapse, setToggleAllCollapse] = useState();

	const [pageReady, setPageReady] = useState(false);

	var sessionAnchor = searchParams.get("anchor");

	useEffect(() => {
		var accordions = {};
		for (var item of questions) {
			accordions[item.ID] = sessionAnchor === item.ID ? true : false;
		}
		setToggleCollapse(accordions);

		if (pageReady && sessionAnchor) {
			// This is needed to avoid race conditions:
			// https://stackoverflow.com/questions/779379/why-is-settimeoutfn-0-sometimes-useful
			// Also the timer (360) needs to be at least higher than the transition time for the accordions (.35s)
			setTimeout(() => {
				findAnchor(sessionAnchor);
			}, 360);
		}
	}, [questions, searchParams, pageReady]);

	function toggleAll() {
		var accordions = {};
		for (var item of questions) {
			accordions[item.ID] = !toggleAllCollapse;
			setToggleAllCollapse(!toggleAllCollapse);
		}
		setToggleCollapse(accordions);
	}

	if (!toggleCollapse) return null;

	if (pageReady && !window.history.state && sessionAnchor) {
		setTimeout(() => {
			findAnchor(sessionAnchor);
		}, 360);
	}

	return (
		<>
			<Button variant="link" onClick={toggleAll} className="toggler text-primary ms-3 me-0">
				Expand/Collapse All Questions
			</Button>
			{questions.map((item, i) => {
				const { ID, Question } = item;

				let sticker = addSticker(item.Modified_Date, item.Sticker_Days, item.Sticker);

				// NOTE: The only (!) way to check if the FAQs set is fully loaded and rendered,
				// is to check if each element is the last item in its array. This logic follows all
				// the way up through ancestor components: Question < Headers < AlphaHeaders
				// it can be found in the props of each of these
				if (lastHeaderLoaded && i + 1 === questions.length && !pageReady) setPageReady(true);

				return (
					<div key={ID} id={ID}>
						<a
							href={window.location.hash.split("?")[0] + "?anchor=" + ID}
							className={"text-primary panelTrigger px-3 " + toggleCollapse[item.ID]}
							onClick={(e) => {
								e.preventDefault();

								// Update URL with anchor every time the Question is cliked
								window.history.replaceState({}, "", window.location.hash.split("?anchor=")[0] + "?anchor=" + ID);
								setToggleCollapse({
									...toggleCollapse,
									[item.ID]: !toggleCollapse[item.ID],
								});
							}}
						>
							{i + 1 + ". " + Question} {sticker && <span className={"sticker " + item.Sticker}>{item.Sticker}</span>}
						</a>
						<Collapse in={toggleCollapse[item.ID]}>
							<div className="ps-3 pb-3 answerBox" dangerouslySetInnerHTML={{ __html: item.Answer }}></div>
						</Collapse>
					</div>
				);
			})}
		</>
	);
}

export default Questions;
